module.exports = __webpack_public_path__ + "static/media/bell.d37eeee1.svg";